<template>
    <div class="flex items-center space-x-4 animate-pulse p-2 rounded-lg border border-gray-200">
        <div class="flex-grow space-y-2">
            <div class="h-4 bg-gray-300 rounded w-3/4"></div>
            <div class="h-4 bg-gray-300 rounded w-1/2"></div>
            <div class="h-3 bg-gray-300 rounded w-1/4"></div>
        </div>
    </div>
</template>
